import { render, staticRenderFns } from "./MakeupArtists.vue?vue&type=template&id=c2da79e4"
import script from "./MakeupArtists.vue?vue&type=script&lang=js"
export * from "./MakeupArtists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../ct-id-20261026/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports